import { actionCreator } from 'utils';
import * as SegmentTypes from '../types/segmentTypes';

// L O A D   S E G M E N T S
export function loadSegments() {
    return {
        type: SegmentTypes.LOAD_SEGMENTS,
    };
}

export function loadSegmentsRes(data) {
    return {
        type: actionCreator(SegmentTypes.LOAD_SEGMENTS, 'res'),
        data,
    };
}

export function loadSegmentsErr() {
    return {
        type: actionCreator(SegmentTypes.LOAD_SEGMENTS, 'err'),
    };
}
// L O A D   S E G M E N T S

// S E T   S E G M E N T S   F I L T E R
export function setSegmentsFilters(key, value) {
    return {
        type: SegmentTypes.SET_SEGMENTS_FILTER,
        key,
        value,
    };
}

export function setSegmentsFiltersRes(data) {
    return {
        type: actionCreator(SegmentTypes.SET_SEGMENTS_FILTER, 'res'),
        data,
    };
}

export function setSegmentPagination(key, pagination) {
    return {
        type: SegmentTypes.SET_SEGMENT_PAGINATION,
        key,
        pagination,
    };
}

export function setSegmentSort(sort) {
    return {
        type: SegmentTypes.SET_SEGMENT_SORT,
        sort,
    };
}
// S E T   S E G M E N T S   F I L T E R

// L O A D   E D I T A B L E   S E G M E N T S
export function loadEditableSegment(id, isChild) {
    return {
        type: SegmentTypes.LOAD_EDITABLE_SEGMENT,
        id,
        isChild,
    };
}

export function loadEditableSegmentRes(data) {
    return {
        type: actionCreator(SegmentTypes.LOAD_EDITABLE_SEGMENT, 'res'),
        data,
    };
}

export function loadEditableSegmentErr() {
    return {
        type: actionCreator(SegmentTypes.LOAD_EDITABLE_SEGMENT, 'err'),
    };
}

export function setEmptyEditableSegment() {
    return {
        type: SegmentTypes.SET_EMPTY_EDITABLE_SEGMENT,
    };
}
// L O A D   E D I T A B L E   S E G M E N T S

// R E S T   F I L T E R   S E G M E N T S
export function resetFiltersSegments() {
    return {
        type: SegmentTypes.RESET_FILTER_SEGMENTS,
    };
}

export function resetFiltersSegmentsRes(data) {
    return {
        type: actionCreator(SegmentTypes.RESET_FILTER_SEGMENTS, 'res'),
        data,
    };
}
// R E S T   F I L T E R   S E G M E N T S

// A D D   N E W   S E G M E N T
export function addNewSegment(data) {
    return {
        type: SegmentTypes.ADD_NEW_SEGMENT,
        data,
    };
}

export function addNewSegmentRes(loading, success) {
    return {
        type: actionCreator(SegmentTypes.ADD_NEW_SEGMENT, 'res'),
        loading,
        success,
    };
}

export function addNewSegmentErr(error) {
    return {
        type: actionCreator(SegmentTypes.ADD_NEW_SEGMENT, 'err'),
        error,
    };
}
// A D D   N E W   S E G M E N T

// E D I T   S E G M E N T
export function editSegment(data) {
    return {
        type: SegmentTypes.EDIT_SEGMENT,
        data,
    };
}

export function editSegmentRes(loading, success) {
    return {
        type: actionCreator(SegmentTypes.EDIT_SEGMENT, 'res'),
        loading,
        success,
    };
}

export function editSegmentErr() {
    return {
        type: actionCreator(SegmentTypes.EDIT_SEGMENT, 'err'),
    };
}
// E D I T   S E G M E N T

// S E T   D I S A B L E   S E G M E N T
export function toggleSegmentStatus(value, key) {
    return {
        type: SegmentTypes.TOGGLE_SEGMENT_STATUS,
        value,
        key,
    };
}

export function toggleSegmentStatusRes(data) {
    return {
        type: actionCreator(SegmentTypes.TOGGLE_SEGMENT_STATUS, 'res'),
        data,
    };
}
// S E T   D I S A B L E   S E G M E N T

// L O A D   S U B   S E G M E N T S
export function loadSubSegments(data) {
    return {
        type: SegmentTypes.LOAD_SUB_SEGMENTS,
        data,
    };
}

export function loadSubSegmentsRes(data) {
    return {
        type: actionCreator(SegmentTypes.LOAD_SUB_SEGMENTS, 'res'),
        data,
    };
}

export function loadSubSegmentsErr() {
    return {
        type: actionCreator(SegmentTypes.LOAD_SUB_SEGMENTS, 'err'),
    };
}
// L O A D   S U B   S E G M E N T S
